import React, { FC } from 'react';
import classNames from 'classnames';
import key from 'weak-key';
import PackageOption, { PackageOptionProps }
  from '@/pages/MarketReportsPreviewPage/components/PackageOption/PackageOption';
import styles from './PackageOptions.module.scss';

export interface PackageOptionsProps {
  title: string;
  allFeaturesLabel: string;
  showLessLabel: string;
  columns: PackageOptionProps[];
  className?: string;
}

const PackageOptions: FC<PackageOptionsProps> = ({
  title, columns, allFeaturesLabel, showLessLabel, className,
}: PackageOptionsProps) => {
  const toggleLabels = { less: showLessLabel, more: allFeaturesLabel };

  const optionsView = columns.map((option) => (
    <PackageOption
      toggleLabels={toggleLabels}
      className={styles.option}
      key={key(option)}
      {...option}
    />
  ));

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.options}>{optionsView}</div>
    </div>
  );
};

export default PackageOptions;
